export const monthNamesFull = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const monthNamesShort = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const CHART_COLORS = {
  // One line per event type, cycled if there are more event types than
  // colors - same palette as OverviewChartCard so a given event type reads
  // as the same color in both charts.
  palette: [
    '#8C9BED',
    '#FB923C',
    '#34D399',
    '#F472B6',
    '#60A5FA',
    '#FBBF24',
    '#A78BFA',
    '#4ADE80',
  ],
  grid: "#E5E7EB",
};
